import React from 'react';
import PropTypes from 'prop-types';
import InputContainer from "../inputContainer";
import InputErrorMessage from "../inputErrorMessage";
import './index.scss';

function Input({ error, errorMessage, ...props }) {
	return (
		<InputContainer>
			<input {...props} className={`app-input ${error ? 'error' : ''} ${props.className}`} />
			{error && errorMessage && <InputErrorMessage errorMessage={errorMessage} />}
		</InputContainer>
	);
}
Input.propTypes = {
	className: PropTypes.string,
	placeholder: PropTypes.string,
	id: PropTypes.string,
	error: PropTypes.bool,
	errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	name: PropTypes.string,
	value: PropTypes.any,
	disabled: PropTypes.any,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
};

export default Input;
